import { useQuery, useQueryClient } from '@tanstack/react-query';
import { listInvites, type PendingInvite } from '@/lib/callables';
import { useMyRole } from '@/hooks/useMyRole';

export type { PendingInvite };

export function useInvites(aid: string | null): {
  invites: PendingInvite[];
  loading: boolean;
  refetch: () => void;
} {
  const myRole = useMyRole(aid);
  const isAdmin = myRole === 'admin';

  const { data, isLoading, refetch } = useQuery({
    queryKey: ['invites', aid],
    queryFn: async () => {
      const result = await listInvites({ accountId: aid! });
      return result.data.invites;
    },
    enabled: !!aid && isAdmin,
    staleTime: 30_000,
  });

  return {
    invites: data ?? [],
    loading: isLoading && isAdmin,
    refetch,
  };
}

/** Call after a create/revoke to refresh the invite list. */
export function useInvalidateInvites() {
  const qc = useQueryClient();
  return (aid: string) => qc.invalidateQueries({ queryKey: ['invites', aid] });
}
